import { render, staticRenderFns } from "./Rescue.vue?vue&type=template&id=19094adc&scoped=true"
import script from "./Rescue.vue?vue&type=script&lang=js"
export * from "./Rescue.vue?vue&type=script&lang=js"
import style0 from "./Rescue.vue?vue&type=style&index=0&id=19094adc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19094adc",
  null
  
)

export default component.exports